import React, { useEffect, useState } from "react";
import Profile_Bg from "../../Assets/Images/Profile_BG.png";
import profilePic from "../../Assets/Images/profile_Pic.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FaExternalLinkAlt } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import CheckOutModal from "../../components/AdminSideComponents/CheckOutModal";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { SlEnergy } from "react-icons/sl";
import { IoBedOutline } from "react-icons/io5";

const TenantProfilePage = () => {
  const [loading, setLoading] = useState(false); //State for loader
  const [openCheckOutModal, setOpenCheckOutModal] = useState(false);
  const [checkInDetails, setCheckInDetails] = useState({}); //State for storing the checkin details
  const { id } = useParams();
  console.log("Id: ", id);

  //Function to get checkin data by ID
  const getCheckInById = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/get_check_in/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Resonse of getCheckInById: ", response.data);
        setCheckInDetails(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getCheckInById();
  }, []);

  console.log("CheckIn Details: ", checkInDetails);
  return (
    <div className="p-2 sm:p-4 md:p-6 tracking-wide">
      {openCheckOutModal && (
        <CheckOutModal
          isOpen={openCheckOutModal}
          onClose={() => setOpenCheckOutModal(false)}
          currentCheckIn={checkInDetails}
        />
      )}
      <div
        style={{ backgroundImage: `url(${Profile_Bg})` }}
        className="bg-cover bg-center bg-no-repeat h-48 sm:h-64 md:h-72 lg:h-[20rem] bg-white mb-4 rounded-lg flex justify-center items-center flex-col gap-1 text-white relative"
      >
        <button
          className="bg-red-600 font-bold text-white absolute top-2 hover:bg-red-700 right-2 px-2 py-2 rounded-lg text-xs flex items-center gap-1 "
          onClick={() => setOpenCheckOutModal(true)}
        >
          Check Out <IoIosLogOut />
        </button>
        <img
          src={checkInDetails?.photo}
          alt="No Image"
          className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 object-cover rounded-full"
        />
        <h1 className="font-semibold text-base sm:text-lg md:text-xl">
          {checkInDetails?.name}
        </h1>
        <p className="font-extralight text-sm sm:text-base">
          {checkInDetails?.city}, {checkInDetails?.state}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 my-4">
        <div className="p-6 bg-purple-100 flex justify-between rounded-lg shadow-lg">
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-bold tracking-wide text-primaryTextColor">
              {checkInDetails?.rentOfThisMonth}/-
            </h2>
            <p className="text-slate-400 text-base font-semibold">
              Bed Rent of this month
            </p>
          </div>
          <div className="bg-white p-2 rounded h-fit w-fit ">
            <IoBedOutline size={26} className="text-purple-700" />
          </div>
        </div>
        <div className="p-6 bg-cyan-100 flex justify-between rounded-lg shadow-lg">
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-bold tracking-wide text-primaryTextColor">
              {checkInDetails?.electricity}/-
            </h2>
            <p className="text-slate-400 text-base font-semibold">
              Electricity Bill of previous month
            </p>
          </div>
          <div className="bg-white p-2 rounded h-fit w-fit ">
            <SlEnergy size={26} className="text-cyan-700" />
          </div>
        </div>
        <div className="p-6 bg-red-100 flex justify-between rounded-lg shadow-lg">
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-bold tracking-wide text-primaryTextColor">
              {checkInDetails?.amountOutstanding}/-
            </h2>
            <p className="text-slate-400 text-base font-semibold">
              Amount Outstanding
            </p>
          </div>
          <div className="bg-white p-2 rounded h-fit w-fit ">
            <LiaRupeeSignSolid size={26} className="text-red-700" />
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-4 w-full">
        {/* Personal Info Section */}
        <div className="w-full lg:w-[60%] p-4 sm:p-6 rounded-lg shadow-lg bg-white">
          <h2 className="text-lg sm:text-xl md:text-[22px] font-semibold mb-4">
            Personal Info
          </h2>
          <ul className="space-y-2">
            {[
              { label: "Aadhaar Number", value: checkInDetails?.aadhaar },
              { label: "Pan Number", value: checkInDetails?.pan || "N/A" },
              { label: "Phone Number", value: checkInDetails?.mobile },
              { label: "Email Id", value: checkInDetails?.email },
              {
                label: "Address",
                value: checkInDetails?.homeAddress,
              },
              {
                label: "City",
                value: checkInDetails?.city,
              },
              {
                label: "State",
                value: checkInDetails?.state,
              },
              {
                label: "Checked In",
                value: new Date(checkInDetails?.joiningDate)
                  .toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                  .replace(/\//g, "-"),
              },
              {
                label: "Emergency Person Name",
                value: checkInDetails?.sosPersonName,
              },
              {
                label: "Emergency Contact Number",
                value: checkInDetails?.sosContact,
              },
              {
                label: "Building Name",
                value: checkInDetails?.hostelName?.nameBuilding,
              },
              {
                label: "Room Number",
                value: `R-F${checkInDetails?.floorNo}${String(
                  checkInDetails?.roomId?.roomNumber
                ).padStart(3, "0")}`,
              },
              { label: "Bed Number", value: checkInDetails?.bedId?.bedNumber },

              {
                label: "Booking Amount",
                value: `Rs.${checkInDetails?.bookingAmount}`,
              },
              {
                label: "Bed Rent",
                value: `Rs.${checkInDetails?.bedRent}`,
              },
              {
                label: "Security Deposit",
                value: `Rs.${checkInDetails?.securityDeposit}`,
              },

              {
                label: "On Notice",
                value: checkInDetails?.notice?.UnderNotice ? "Yes" : "No",
              },
            ].map((item, index) => (
              <li
                key={index}
                className="text-gray-600 text-base sm:text-lg font-medium flex flex-col sm:flex-row sm:justify-between gap-1"
              >
                {item.label}:{" "}
                <span className="font-medium text-[#878A99] break-all sm:break-normal">
                  {item.value}
                </span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-4">
            <div className="text-gray-600 my-4 text-base sm:text-lg font-medium flex flex-col gap-1">
              <label htmlFor="">Aadhaar Front : </label>
              <a href={checkInDetails.aadhaarFront} target="_blank">
                <img
                  src={checkInDetails.aadhaarFront}
                  alt="Aadhaar Front Page"
                  className="w-[50%] rounded-lg hover:scale-105 ease-in-out duration-300 transition-transform"
                />
              </a>
            </div>
            <div className="text-gray-600 my-4 text-base sm:text-lg font-medium flex flex-col gap-1">
              <label htmlFor="">Aadhaar Back : </label>
              <a href={checkInDetails.aadhaarBack} target="_blank">
                <img
                  src={checkInDetails.aadhaarBack}
                  alt="Aadhaar Back Page"
                  className="w-[50%] rounded-lg  hover:scale-105 ease-in-out duration-300 transition-transform"
                />
              </a>
            </div>
          </div>

          <div className=" gap-4 text-gray-600 my-4 text-base sm:text-lg font-medium">
            <label htmlFor="">Police Verification Forms : </label>
            <div className="flex flex-wrap gap-4">
              {checkInDetails?.policeVerification?.map((police, index) => (
                <a href={police} target="_blank">
                  <div className="bg-gray-200 hover:bg-gray-300 text-lg rounded-lg px-6 py-2 font-semibold mt-2 relative">
                    Form {index + 1}
                    <FaExternalLinkAlt
                      color="blue"
                      size={12}
                      className="absolute top-0 right-0"
                    />
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div className=" gap-4 text-gray-600 my-4 text-base sm:text-lg font-medium">
            <label htmlFor="">Terms and Conditons : </label>
            <div className="flex flex-wrap gap-4">
              {checkInDetails?.terms?.map((term, index) => (
                <a href={term} target="_blank">
                  <div className="bg-gray-200 hover:bg-gray-300 text-lg rounded-lg px-6 py-2 font-semibold mt-2 relative">
                    Term {index + 1}
                    <FaExternalLinkAlt
                      color="blue"
                      size={12}
                      className="absolute top-0 right-0"
                    />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Secondary Container */}
        <div className="w-full lg:w-[40%] flex flex-col gap-4">
          {/* Payments Section */}
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg max-h-[500px] overflow-y-auto">
            <div className="flex  justify-between items-center">
              <h2 className="text-lg sm:text-xl md:text-[22px] font-semibold mb-4">
                Payments
              </h2>
              <h2
                className={`text-sm px-2 py-1 rounded-lg shadow-lg  font-semibold mb-4 ${
                  checkInDetails?.amountOutstanding === 0
                    ? "bg-green-200"
                    : "bg-red-100"
                }`}
              >
                Amount Outstanding :{" "}
                <span
                  className={`${
                    checkInDetails?.amountOutstanding === 0
                      ? "text-green-700"
                      : "text-red-700"
                  }`}
                >
                  {checkInDetails?.amountOutstanding}/-
                </span>
              </h2>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-gray-600 min-w-[400px]">
                <thead>
                  <tr>
                    <th className="border-b py-2 text-left text-sm sm:text-base">
                      Date
                    </th>
                    <th className="border-b py-2 text-left text-sm sm:text-base">
                      Amount
                    </th>
                    <th className="border-b py-2 text-left text-sm sm:text-base">
                      Due
                    </th>
                    <th className="border-b py-2 text-left text-sm sm:text-base">
                      Type
                    </th>
                    <th className="border-b py-2 text-left text-sm sm:text-base">
                      Mode
                    </th>
                    <th className="border-b py-2 text-left text-sm sm:text-base">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {checkInDetails?.monthlyPayments
                    ?.slice() // Create a shallow copy to avoid mutating the original array
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .map(
                      (
                        payments,
                        index // Sort latest first
                      ) => (
                        <tr key={index} className="text-sm sm:text-base">
                          <td className="border-b py-2">
                            {new Date(payments.createdAt)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })
                              .replace(/\//g, "-")}
                          </td>
                          <td className="border-b py-2">
                            {payments.paymentId.amountPaid}.00
                          </td>
                          <td className="border-b py-2">
                            {payments.paymentId.dueCarryOver}.00
                          </td>
                          <td className="border-b py-2">
                            {payments.paymentId.paymentType}
                          </td>
                          <td className="border-b py-2">
                            {payments.paymentId.modeOfPayment}
                          </td>
                          <td
                            className={`border-b py-2 ${
                              payments.paymentId.dueCarryOver === 0
                                ? "text-green-500"
                                : "text-red-500"
                            }`}
                          >
                            {payments.paymentId.status}
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Issues Section */}
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg">
            <h2 className="text-lg sm:text-xl md:text-[22px] font-semibold mb-4">
              Issues
            </h2>
            {/* <div className="space-y-4">
              {[1, 2].map((num) => (
                <div
                  key={num}
                  className="flex flex-col sm:flex-row justify-between text-gray-600 gap-2"
                >
                  <div className="flex-1">
                    <p className="font-medium text-base sm:text-lg">
                      Issues No - {num}
                    </p>
                    <p className="text-sm sm:text-base">
                      Hello sir, One of my light bulb is not working, can you
                      please look into? And bathroom tap is also broken.
                    </p>
                    <p className="text-gray-500 text-xs sm:text-sm">
                      Date 23 Apr 2024
                    </p>
                  </div>
                  <span className="text-green-500 font-medium text-sm sm:text-base">
                    Resolved
                  </span>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantProfilePage;
